var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_5873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59996 2.82667C7.05885 2.71925 7.52867 2.66556 7.99996 2.66667C12.6666 2.66667 15.3333 8 15.3333 8C14.9286 8.75707 14.446 9.46982 13.8933 10.1267M9.41329 9.41333C9.23019 9.60983 9.00939 9.76744 8.76406 9.87675C8.51873 9.98606 8.25389 10.0448 7.98535 10.0496C7.71681 10.0543 7.45007 10.0049 7.20103 9.90433C6.952 9.80374 6.72577 9.65402 6.53586 9.4641C6.34594 9.27419 6.19622 9.04796 6.09563 8.79893C5.99504 8.54989 5.94564 8.28315 5.95038 8.01461C5.95512 7.74607 6.0139 7.48123 6.12321 7.2359C6.23252 6.99057 6.39013 6.76977 6.58663 6.58667M0.666626 0.666668L15.3333 15.3333M11.96 11.96C10.8204 12.8287 9.4327 13.3099 7.99996 13.3333C3.33329 13.3333 0.666626 8 0.666626 8C1.49589 6.4546 2.64605 5.10441 4.03996 4.04L11.96 11.96Z",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_5873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility-off.d60f51f93065c436aa0209dfbf12f63e.svg";
export { ForwardRef as ReactComponent };